








import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
	name: 'NyGovCallback'
})
export default class NyGovCallback extends Vue {
	public async beforeCreate() {
		const id = this.$route.query['id'];
		await this.$store.dispatch('AuthModule/getJwtToken', id);
		this.$router.push('/');
	}
}
